import { useEffect, useState, useContext } from "react";

import { Plus, Minus } from "../../files/icons/index.js";

import Drop from "./drop.js";

import { AppContext } from '../../context.js';

import { TimestampToDate, DatetimeToDate, DateToFormat } from "../../utils/datetime.js";

function RecurrencePicker(props) {
  const { recurreAt, onChange, onChangeID, leftText, leftIcon, rightIcon, className, disabled = false } = props;

  const context = useContext(AppContext);

  const [next, setNext] = useState(recurreAt); // date
  const [intervalType, setIntervalType] = useState(1); // 1 = days, 2 = weeks, 3 = months, 4 = years
  const [intervalDuration, setIntervalDuration] = useState(1); // number of days/weeks/months/years
  const [fromType, setFromType] = useState(1); // 1 = date of creation, 2 = today

  const [closeDrop, setCloseDrop] = useState(0);

  useEffect(() => {
    setNext(recurreAt);
    setIntervalDuration(1);
    setIntervalType(1);
    setFromType(1);
  }, [recurreAt]);

  function changeIntervalDuration(number) {
    number = parseInt(number);
    if (number > 0) {
      setIntervalDuration(number);
    }
  }

  function save() {
    onChange(onChangeID, intervalType, intervalDuration, fromType);
    setCloseDrop(closeDrop + 1);
  }

  function remove() {
    onChange(onChangeID, null, null, null);
    setCloseDrop(closeDrop + 1);
  }

  const trigger = (
    <div className={"item grey " + className} style={disabled ? { opacity: 0.7, cursor: "default" } : undefined}>
      {leftIcon && leftIcon}
      {leftText && <span className="typo-normal-150">{leftText}</span>}
      <span className="typo-normal-150">{recurreAt ? DateToFormat(DatetimeToDate(recurreAt), context.dateFormat) : 'not set'}</span>
      {!disabled && rightIcon}
    </div>
  );

  if (disabled) {
    return trigger;
  }

  return (
    <Drop close={closeDrop}>
      {trigger}
      <div className="card shadowmore" style={{minWidth: 200}}>
        <div className="card-header sm">
          {next ? (
            <>
              <div className="typo-normal-150 text-muted">Next recurrence:</div>
              <div className="typo-medium-150">{DateToFormat(DatetimeToDate(next), context.dateFormat)}</div>
            </>
          ) : (
            <>
              <div className="typo-normal-150 text-muted">Repeat every:</div>
              <div className="d-flex justify-content-between">
                <div onClick={() => changeIntervalDuration(intervalDuration - 1)} className="item grey me-1">
                  <Minus height={16} width={16} color={'grey'} />
                </div>
            
                <input type="text" className="input borderless text-center typo-normal-150" value={intervalDuration} onChange={(e) => changeIntervalDuration(e.target.value)} style={{width: 30}} />

                <div onClick={() => changeIntervalDuration(intervalDuration + 1)} className="item grey ms-1">
                  <Plus height={16} width={16} color={'grey'} />
                </div>

                <div className={'item ms-2 ' + (intervalType === 1 ? 'blue' : 'grey')} onClick={() => setIntervalType(1)}><span className="typo-normal-150">Days</span></div>
                <div className={'item ms-2 ' + (intervalType === 2 ? 'blue' : 'grey')} onClick={() => setIntervalType(2)}><span className="typo-normal-150">Weeks</span></div>
                <div className={'item ms-2 ' + (intervalType === 3 ? 'blue' : 'grey')} onClick={() => setIntervalType(3)}><span className="typo-normal-150">Months</span></div>
                <div className={'item ms-2 ' + (intervalType === 4 ? 'blue' : 'grey')} onClick={() => setIntervalType(4)}><span className="typo-normal-150">Years</span></div>
              </div>

              <div className="typo-normal-150 text-muted mt-1">From:</div>
              <div className="d-flex justify-content-start">
                <div className={'item me-2 ' + (fromType === 1 ? 'blue' : 'grey')} onClick={() => setFromType(1)}><span className="typo-normal-150">Date of creation</span></div>
                <div className={'item me-2 ' + (fromType === 2 ? 'blue' : 'grey')} onClick={() => setFromType(2)}><span className="typo-normal-150">Today</span></div>
              </div>
            </>
          )}
        </div>
        <div className="card-content sm text-end">
          {next ? (
            <div className="item grey ms-2" onClick={() => remove()}><span className="typo-normal-150">Remove</span></div>
          ) : (
            <div className="item grey" onClick={() => save()}><span className="typo-normal-150">Save</span></div>
          )}
        </div>
      </div>
    </Drop>
  );
}

export default RecurrencePicker;